import { GoalState } from './Interfaces/GoalsState';

export const goalsInitialState: GoalState = {
    currentGoals: null,
};
